import '../Styles/footer.css';
import styled from 'styled-components';
import impulsione from '../../Media/logo-impulsionegram.png';
import { useEffect, useState } from 'react';
import * as routes from '../../routes';
import { Tools } from '../Tools';
import { Faq } from '../Tools/Faq';
const Footer = () => {
  const [currentPage, setCurrentPage] = useState('');
  let { pathname } = window.location;
  const t1 = pathname.includes(routes.STORY);
  const t2 = pathname.includes(routes.FEED);
  const t3 = pathname.includes(routes.FOTO);
  const t4 = pathname.includes(routes.REELS);
  const t5 = pathname.includes(routes.VIDEO);
  const t6 = pathname.includes(routes.HOME);
  const t = pathname.includes('/ferramentas/');

  return (
    <>
      <footer
        className={`footer ${
          t && !t1 && !t2 && !t3 && !t4 && !t5 ? 'position' : ''
        }`}
      >
        <Wrapper>
          <Small>
            <div class="cta-section footer-cta py-24 bg-pattern pattern-3">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <div class="text-center dark-mode-texts">
                      <h2 class="gr-text-2 mb-12">
                        Pronto para bombar o seu Instagram?
                      </h2>{' '}
                      <a
                        href="https://www.impulsionegram.com.br/#planos"
                        class="btn btn-green btn-cta btn-rounded text-white gr-hover-y px-lg-9 goto"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Comprar Seguidores Agora
                      </a>
                      <p class="text-white mb-0 mt-6">
                        Leva menos de 5 minutos!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="footer-section bg-default-4 py-4">
                <div class="container">
                  <div class="row justify-content-center align-items-center flex-column-reverse flex-md-row">
                    <div class="col-lg-4 col-md-5">
                      <div class="footer-logo text-center text-md-left mt-4 mb-7 mb-md-0 mt-7 mt-md-0">
                        {' '}
                        <img
                          src={impulsione}
                          alt=""
                          class="light-version-logo mx-auto mx-md-0"
                        />{' '}
                      </div>
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-7">
                      <ul class="footer-links flex gr-text-11 py-lg-7 list-unstyled mb-0 d-xs-flex align-items-center justify-content-around justify-content-md-end flex-wrap">
                        <li class="ml-md-12 text-center me-md-5">
                          <a
                            href="https://www.impulsionegram.com.br/blog/"
                            class="gr-text-color gr-hover-text-blue font-weight-bold "
                          >
                            Blog
                          </a>
                        </li>
                        <li class="ml-md-12 text-center me-md-5">
                          <a
                            href="https://www.impulsionegram.com.br/privacidade/"
                            class="gr-text-color gr-hover-text-blue font-weight-bold "
                          >
                            Política de Privacidade
                          </a>
                        </li>
                        <li class="ml-md-12 text-center">
                          <a
                            href="https://www.impulsionegram.com.br/termos-de-uso/"
                            class="gr-text-color gr-hover-text-blue font-weight-bold "
                          >
                            Termos de Compra
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* &copy;2022 <strong>ImpulsioneGram</strong> ❤️ */}
          </Small>
          <FooterNav></FooterNav>
        </Wrapper>
      </footer>
    </>
  );
};

const Head = styled.div`
  font-size: 50px;
  text-align: center;
  font-weight: bold;
  /* background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  ); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Mains = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 14vh;
`;

const Cards = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const CardItem = styled.li`
  display: flex;

  padding: 0.7rem;
  @media (min-width: 40rem) {
    .cards_item {
      width: 50%;
    }
  }

  @media (min-width: 56rem) {
    .cards_item {
      width: 33.3333%;
    }
  }
`;

const Wrapper = styled.div`
  vertical-align: middle;
`;

const Small = styled.div`
  color: #ccc;
`;

const FooterNav = styled.div``;

export default Footer;
